// Register global filters
import Vue from 'vue'
import { usd } from './usd'
import { phoneNumber } from './phoneNumber'

Vue.filter('usd', usd)
Vue.filter('phoneNumber', phoneNumber)
